/* eslint-disable */
import React, { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import "./Products.css";
import Sidebar from "../../components/sidebar/Sidebar2";
import Navbar from "../../components/navbar/Navbar2";
import Footer from "../../components/footer/Footer";
import { serverTimestamp } from "firebase/firestore";
import DataTableAi from "../../components/products/DataTableTemplatingDemo/DataTableAi";
import ModelAdd from "../../components/products/model/ModelAdd";
import ModelShow from "../../components/products/model/ModelShow";
import Swal from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import { useTranslation } from "react-i18next";
import { Search, Plus } from "lucide-react";

function Products() {
  const [lgShow, setLgShow] = useState(false);
  const [modelShow, setModelShow] = useState(false);
  const [showSideBar, setShowSideBar] = useState(true);
  const [data2, setData2] = useState(["", "", "", "", ""]);
  const store = useSelector((state) => state.StoreReducer);
  const account = useSelector((state) => state.AccountReducer);
  const [adAccounts, setAdAccounts] = useState([]);
  const [selectedAccount, setSelectedAccount] = useState("");
  const accessToken = store.accessTokenFacebookAds;
  const [filter, setFilter] = useState("");
  const [pageSize, setPageSize] = useState(10);
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar"; // ou toute autre langue RTL

  const [images, setImages] = useState([
    {
      original: "https://picsum.photos/id/1018/1000/600/",
      thumbnail: "https://picsum.photos/id/1018/250/150/",
    },
    {
      original: "https://picsum.photos/id/1015/1000/600/",
      thumbnail: "https://picsum.photos/id/1015/250/150/",
    },
    {
      original: "https://picsum.photos/id/1019/1000/600/",
      thumbnail: "https://picsum.photos/id/1019/250/150/",
    },
  ]);

  const [data, setData] = useState({
    name: "",
    image: "",
    review: "",
    price: "",
    oldPrice: "",
    comment: "",
    qty: "",
    category_id: "",
    sku: "",
    show: "1",
    short: "",
    options: [
      {
        title: "1",
        color: "1",
        colorOption: [
          {
            option: "",
            color: "",
          },
        ],
      },
    ],
    discount: {
      freeDelivery: true,
      discountDelivery: 0,
      discountTotal: 0,
    },
    offers: [
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
      {
        title: "",
        qty: 0,
        price: 0,
      },
    ],
    gallery: [],
    textEditor: "<p><br></p>",
    timeStamp: serverTimestamp(),
  });

  const message = () => {
    const MySwal = withReactContent(Swal);
    const swalWithBootstrapButtons = Swal.mixin({
      customClass: {
        confirmButton: "btn btn-success mx-2",
        cancelButton: "btn btn-danger mx-2",
      },
      buttonsStyling: false,
    });

    swalWithBootstrapButtons
      .fire({
        title:
          t("services.contact_for_free_trial"),
        showCancelButton: true,
        confirmButtonText: t("ship.yes"),
        cancelButtonText: t("ship.no"),
        reverseButtons: true,
      })
      .then((result) => {
        if (result.isConfirmed) {
          window.open("https://m.me/F0orweb", "_blank", "noopener,noreferrer");
        } else result.dismiss === Swal.DismissReason.cancel;
      });
  };

  const handleAdd = () => {
    setData({
      name: "",
      image: "",
      review: "",
      price: "",
      oldPrice: "",
      comment: "",
      qty: "",
      category_id: "",
      sku: "",
      show: "1",
      options: [
        {
          title: "",
          color: "1",
          colorOption: [
            {
              option: "",
              color: "",
            },
            {
              option: "",
              color: "",
            },
          ],
          option1: "",
          option2: "",
          option3: "",
          option4: "",
          color1: "",
          color2: "",
          color3: "",
          color4: "",
        },
      ],
      discount: {
        freeDelivery: false,
        activeStay: false,
        discountDelivery: 0,
        discountTotal: 0,
      },
      offers: [
        {
          title: "",
          qty: 0,
          price: 0,
        },
        {
          title: "",
          qty: 0,
          price: 0,
        },
        {
          title: "",
          qty: 0,
          price: 0,
        },
        {
          title: "",
          qty: 0,
          price: 0,
        },
      ],
      gallery: [],
      textEditor: "<p><br></p>",
      timeStamp: serverTimestamp(),
    });
    setLgShow(true);
  };

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  useEffect(() => {
    !!store.id && setData2(store.categories);
  }, [store]);

  useEffect(() => {
    async function fetchAdAccounts() {
      try {
        const response = await fetch(
          `https://graph.facebook.com/v21.0/me/adaccounts?access_token=${accessToken}`
        );
        const data = await response.json();
        setAdAccounts(data.data || []);
      } catch (error) {
        console.error("Error fetching ad accounts:", error);
      }
    }

    if (accessToken) {
      fetchAdAccounts();
    }
  }, [accessToken]);

  return (
    <div
      className="container-fluid bg-purple-50 dark:!bg-[#141414] min-h-screen"
      dir={isRTL ? 'rtl' : 'ltr'}
    >
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
              boxShadow: "2px 0 10px rgba(0,0,0,0.05)",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div className="px-3 dark:!bg-[#141414]" style={{ flex: 1, backgroundColor: "#fbf8fc" }}>
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />

          {/* Page Header */}
          <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 m-3 mt-6 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
            <div className="flex flex-wrap items-center justify-between gap-3">
              <div>
                <h2 className="text-xl font-bold text-[#9e68ba] mb-1">
                  {t("insightads.title")}
                </h2>
                <p className="text-gray-600 mb-0 dark:!text-gray-300">
                  {t("insightads.description")}
                </p>
              </div>
            </div>
          </div>

          {!store.accessTokenFacebookAds ? (
            <>
              {/* Search and Filter Bar */}
              <div className="bg-white dark:!bg-[#181819] rounded-xl shadow-sm p-4 mx-3 mb-4 border border-[#fbf4ff] dark:!border-[#3c3a3d]">
                <div className="flex flex-wrap items-center justify-between gap-3">
                  <div className="relative flex-grow max-w-xl">
                    <div className="absolute inset-y-0 right-0 flex items-center pr-3 pointer-events-none">
                      <Search size={16} className="text-gray-400" />
                    </div>
                    <input
                      type="text"
                      className="bg-gray-50 dark:!bg-[#181819] border border-gray-200 dark:!border-[#3c3a3d] text-gray-900 text-sm rounded-lg block w-full pr-10 p-2.5  focus:outline-none focus:ring-2 focus:ring-purple-200"
                      placeholder={t("insightads.filters.search_placeholder")}
                      value={filter}
                      onChange={(e) => setFilter(e.target.value)}
                    />
                  </div>

                  <div className="flex flex-row items-center gap-x-4">
                    <div className="flex items-center gap-3">
                      <select
                        value={selectedAccount}
                        onChange={(e) => setSelectedAccount(e.target.value)}
                        className="bg-gray-50 border border-gray-200 dark:!border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 focus:ring-purple-200 focus:border-purple-500 w-60 dark:!bg-[#9b59bf] dark:text-white"
                      >
                        <option value="" disabled>
                          {t("insightads.filters.select_account")}
                        </option>
                        {adAccounts.map((acc) => (
                          <option key={acc.id} value={acc.id}>
                            {acc.name} {acc.id.replace("act_", "")}
                          </option>
                        ))}
                      </select>

                      <select
                        value={pageSize}
                        onChange={(e) => setPageSize(e.target.value)}
                        className="bg-gray-50 border border-gray-200 dark:!border-[#9b59bf] text-gray-900 text-sm rounded-lg p-2.5 focus:ring-purple-200 focus:border-purple-500 dark:!bg-[#9b59bf] dark:text-white"
                      >
                        <option value={5} className="bg-gray-50 dark:!bg-[#181819]">{t("insightads.filters.ad_limit.5")}</option>
                        <option value={10} className="bg-gray-50 dark:!bg-[#181819]">{t("insightads.filters.ad_limit.10")}</option>
                        <option value={25} className="bg-gray-50 dark:!bg-[#181819]">{t("insightads.filters.ad_limit.25")}</option>
                        <option value={50} className="bg-gray-50 dark:!bg-[#181819]">{t("insightads.filters.ad_limit.50")}</option>
                      </select>
                    </div>
                  </div>
                </div>
              </div>

              {/* Data Table */}
              <div className="mx-3 bg-white dark:!bg-[#181819] rounded-xl shadow-sm border border-[#fbf4ff] dark:!border-[#3c3a3d] p-0 mb-6 overflow-hidden">
                <DataTableAi
                  lgShow={lgShow}
                  setLgShow={setLgShow}
                  modelShow={modelShow}
                  setModelShow={setModelShow}
                  setImages={setImages}
                  data={data}
                  selectedAccount={selectedAccount}
                  setData={setData}
                  filter={filter}
                  pageSize={pageSize}
                />
              </div>
            </>

          ) : (
            <div
              className={`bg-white dark:!bg-[#181819] rounded-xl shadow-sm m-3 border border-[#fbf4ff] dark:!border-[#3c3a3d] overflow-hidden ${isRTL ? "rtl" : "ltr"
                }`}
              dir={isRTL ? "rtl" : "ltr"}
            >
              <section className="relative max-w-screen-xl py-6 px-4 md:px-8">
                <div className="gap-5 items-center lg:flex">
                  <div
                    className={`flex-1 max-w-lg py-5 sm:mx-auto sm:text-center lg:max-w-max ${isRTL ? "lg:text-right" : "lg:text-left"
                      }`}
                  >
                    <h3 className="text-2xl text-[#9e68ba] font-semibold md:text-3xl">
                      {t("insightads.section_title")}{" "}
                      <span className="text-[#9e68ba]">{t("insightads.section_highlight")}</span>
                    </h3>
                    <p className="text-gray-600 leading-relaxed mt-3 dark:!text-gray-400">
                      {t("insightads.section_description")}
                    </p>

                    <a
                      className="mt-5 px-6 py-2.5 bg-[#9b59bf] hover:bg-[#814a9f] text-white font-medium rounded-lg inline-flex items-center transition-colors"
                      href="https://admin.foorweb.store/settings/weinsight"
                    >
                      {t("insightads.cta_button")}
                      <svg
                        xmlns="http://www.w3.org/2000/svg"
                        className={`h-5 w-5 transition-transform duration-200 ${isRTL ? "ml-2" : "mr-2 rotate-180"
                          }`}
                        viewBox="0 0 20 20"
                        fill="currentColor"
                      >
                        <path
                          fillRule="evenodd"
                          d="M9.707 14.707a1 1 0 01-1.414 0l-4-4a1 1 0 010-1.414l4-4a1 1 0 011.414 1.414L7.414 9H15a1 1 0 110 2H7.414l2.293 2.293a1 1 0 010 1.414z"
                          clipRule="evenodd"
                        />
                      </svg>

                    </a>
                  </div>

                  <div className="flex-1 mt-8 mx-auto sm:w-9/12 lg:mt-0 lg:w-auto">
                    <img
                      src="/metaFoorweb.png"
                      alt=""
                      className="w-full rounded-lg shadow-md"
                    />
                  </div>
                </div>
              </section>
            </div>

          )}

          <Footer />
        </div>
      </div>
      <ModelAdd
        lgShow={lgShow}
        setLgShow={setLgShow}
        data={data}
        setData={setData}
        categories={data2}
      />
      <ModelShow lgShow={modelShow} setLgShow={setModelShow} images={images} />
    </div>
  );
}

export default Products;
